import type { ComponentPropsWithRef, ReactNode } from 'react';
import cx from 'clsx';
import styles from './content-wrapper.module.css';

export function ContentWrapper({
  children,
  className,
  ...props
}: ComponentPropsWithRef<'div'>): ReactNode {
  return (
    <div className={cx(styles.wrapper, className)} {...props}>
      {children}
    </div>
  );
}
